import { ReactNode } from "react";
import { Box } from "@mui/material";
import { Section, SectionProps } from "src/components/base";
import { useMuiNavHeight } from "src/hooks/use-mui-nav-height";

interface IAreaOverviewModuleContainerProps extends SectionProps {
    sectionNavigationId?: string | null;
    children: ReactNode;
}

export const AreaOverviewModuleContainer = ({ sectionNavigationId, children, ...sectionProps }: IAreaOverviewModuleContainerProps) => {
    const { NAV_HEIGHT_VARIATION } = useMuiNavHeight();
    const NEGATED_NAV_HEIGHT = {
        xs: -NAV_HEIGHT_VARIATION.xs,
        sm: -NAV_HEIGHT_VARIATION.sm,
        md: -NAV_HEIGHT_VARIATION.md,
    };

    return (
        <Section {...sectionProps}>
            {sectionNavigationId && (
                <Box
                    id={sectionNavigationId}
                    sx={{
                        position: "relative",
                        width: 0,
                        height: 0,
                        visibility: "hidden",
                        top: NEGATED_NAV_HEIGHT,
                    }}
                />
            )}
            {children}
        </Section>
    );
};
